function invalidSpecialCharacters(str: string): string {
    const invalid = /[.*+?^${}()|[\]\\]/g;

    return str.replace(invalid, '');
}

// ----------------------------------------------------------------------------

export default invalidSpecialCharacters;
